<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "HelpCenter",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'countryId',
        placeholder: '国家',
        type: 'select',
        selectUrl: '/country/getAll',
        selectData: [],
      }, {
        name: 'type',
        placeholder: '请选择类型',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '普通文章',
          type: 'warning'
        }, {
          key: 1,
          value: '资讯',
          type: 'warning'
        }, {
          key: 2,
          value: '公司介绍',
          type: 'danger'
        }]
      }],
      permission: {
        add: 'helpCenter:add',
        update: 'helpCenter:update',
        delete: 'helpCenter:delete',
        deleteBatch: 'helpCenter:deleteBatch'
      },
      url: {
        get: '/helpCenter/listByCondition',
        add: '/helpCenter/add',
        update: '/helpCenter/update',
        delete: '/helpCenter/delete/',
        delete_batch: '/helpCenter/deleteBatch',
        status: '/helpCenter/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'title',
        label: '标题',
        show: true,
        width: '',
      },  {
        field: 'countryId',
        label: '国家ID',
        selectUrl: '/country/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        detail: false,
        width: '',
      }, {
        field: 'type',
        label: '类型',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '普通文章',
            type: 'blue'
          }, {
            key: 1,
            value: '资讯',
            type: 'warning'
          }, {
            key: 2,
            value: '平台公告',
            type: 'danger'
          }]
        },
      }, {
        field: 'sort',
        label: '排序',
        show: true,
        width: '',
      }, {
        field: 'status',
        label: '状态',
        show: true,
        status: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加公告',
        updateTitle: '修改公告',
        model: [{
          field: 'title',
          label: '标题',
          type: 'input',
          placeholder: '标题',
          rules: [{message: '请输入标题', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'content',
          label: '内容',
          type: 'editor',
          placeholder: '内容',
          rules: [{message: '请输入内容', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'countryId',
          label: '国家',
          type: 'select',
          selectUrl: '/country/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择国家ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'sort',
          label: '排序',
          type: 'input',
          placeholder: '排序',
          rules: [{message: '请输入排序', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'type',
          label: '类型',
          type: 'select',
          selectData: [{
            id: 0,
            name: '普通文章'
          }, {
            id: 1,
            name: '资讯'
          }, {
            id: 2,
            name: '平台介绍'
          }],
          placeholder: '请选择类型',
          rules: [{
            message: '请选择类型', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'createTime',
          label: '时间',
          type: 'dateTime',
          placeholder: '请选择时间',
          rules: [{
            message: '请选择时间', trigger: 'blur', required: true
          }],
          //add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
